var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScmpPlusHighlightsLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.333 3.99991H4.33301C3.80257 3.99991 3.29387 4.21062 2.91879 4.58569C2.54372 4.96075 2.33301 5.46945 2.33301 5.99988V19.9997C2.33301 20.5301 2.54372 21.0388 2.91879 21.4139C3.29387 21.7889 3.80257 21.9997 4.33301 21.9997H18.333C18.8634 21.9997 19.3721 21.7889 19.7472 21.4139C20.1223 21.0388 20.333 20.5301 20.333 19.9997V12.9998",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.833 2.49994C19.2308 2.10212 19.7704 1.87863 20.333 1.87863C20.8956 1.87863 21.4352 2.10212 21.833 2.49994C22.2308 2.89776 22.4543 3.43732 22.4543 3.99992C22.4543 4.56252 22.2308 5.10208 21.833 5.4999L12.333 14.9998L8.33301 15.9998L9.33301 11.9998L18.833 2.49994Z",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.333 3.99994L19.333 5.9999",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.333 18.9997C12.333 18.4475 11.8853 17.9997 11.333 17.9997C10.7807 17.9997 10.333 18.4475 10.333 18.9997L12.333 18.9997ZM12.333 20.9997L12.333 18.9997L10.333 18.9997L10.333 20.9997L12.333 20.9997Z",
  fill: "#4585FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.333 5.99991L11.333 3.99995",
  stroke: "#4585FF",
  strokeWidth: 2,
  strokeLinecap: "round"
}))));
export default SvgScmpPlusHighlightsLogo;